import BaseMoveableItem from './base_moveable_item';
import AlienCorpse from './alien_corpse';

export default class Alien extends BaseMoveableItem {
    constructor(x, y, atlas = 'actors', frame = 'alienB_i.png') {
        super(x, y, atlas, frame);

    }

    static get phrases() {
        return {
            pick: [
                "Blllgh!",
                "Screee!",
                "Aarkh!",
                "Rraw! Scraw!",
                "*bubbling noises*",
                "SCREEEECH!",
                "AAAAAAA!",
                "Excuse me mister, would you please put me down?",
            ],
            land: [
                "Blllgh!",
                "Screee!",
                "Aarkh!",
                "Ack!",
                "SCREEEECH!",
                "AAAAAAA!",
                "Bub!",
                "Pop!",
                "*wet smack*",
                "GRRR!",
            ]
        }
    }

    get eatSound() {
        return 'alien-1';
    }

    static get type() {
        return "alien";
    }

    get movingSpeed() {
        return 100;
    }

    get attackTimeMs() {
        return 5000;
    }

    static get mass() { return 3; }

    onCollideWithObject(object) {
        if (this.attacking) return;
        this.attacking = { object, timeLeft: this.attackTimeMs };
        this.startAttackAnimation(() => {
            game.add.tween(object).to({ alpha: 0.5 }, 200, null, true, undefined, undefined, true);
            if (!game.gameState.canUpdateItem()) return;
            game.sounder.play(this.eatSound);
        })
    }

    startAttackAnimation(onLoop) {
        this.animations.play('attack').onLoop.add(onLoop);

    }

    onHit(object, addItem) {
        this.state = 'destroyed';
        this.animations.play('die').onComplete.add(() => {
            game.sounder.play('alien-2');
            this.destroy();
            addItem(new AlienCorpse(this.x, this.y, this.corpseFrame))
        })
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 21; }
    static get height() { return 8; }

    cancelAttackAnimation() {
        this.animations.getAnimation('attack').onLoop.removeAll();
    }

    update() {
        if (!game.gameState.canUpdateItem()) return;
        super.update();
        if (this.attacking) {
            if (!this.attacking.object.standing) {
                this.attacking = null;
                this.cancelAttackAnimation();
            } else {
                this.mover.stop();
                this.attacking.timeLeft -= game.time.physicsElapsedMS;
                if (this.attacking.timeLeft < 0) {
                    this.attacking.object.explode();
                    this.attacking = null;
                    this.cancelAttackAnimation();
                }
            }
        } else if (this.walking && !this.mover.isMoving) {
            this.mover.moveRandomExceptLastEdge();
            this.animations.play('move');
        }

    }

    static get label() {
        return "alien";
    }

    static get description() {
        return "This is an alien lifeform. It's not really friendly!";
    }
}


// WEBPACK FOOTER //
// ./src/objects/items/moveable/alien.js